<template>
    <div class="person">
        <!-- <div class="condition">
            <div class="item">
                <div class="label">角色名称:</div>
                <el-input v-model="conditionData.name" size="small" placeholder="请输入角色名称"></el-input>
            </div>
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
            </div>
        </div> -->

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="showAddDialog">新建</el-button>
                    <!-- <el-button type="primary" icon="el-icon-edit" size="small" @click="updateDialogShow()">修改人员信息</el-button> -->
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column
                type="selection"
                width="80"
                align="center"
                >
                </el-table-column>
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="compnay"
                label="保险公司"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="userName"
                label="负责人"
                align="center"
                width="200"
                >
                </el-table-column>
                <!-- <el-table-column
                prop="caseType"
                label="案件类型"
                align="center"
                width="200"
                >
                </el-table-column> -->
                <el-table-column
                prop="provinceListStr"
                label="省份"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="cityListStr"
                label="城市"
                align="center"
                >
                </el-table-column>
                
                <el-table-column
                fixed="right"
                label="操作"
                width="200px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="isUpdateDialogShow(scope.row)">编辑</el-button>
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteAutoConfigureTip(scope.row)">删除</el-button>
                </template>
                </el-table-column>
            </el-table>

            <!-- <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next, total"
                    :total="totalCount"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
                
            </div> -->
        </div>


        <el-dialog :close-on-click-modal="false" :visible.sync="isAddDialog" title="新增" width="600px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        公司名称:
                    </div>
                    <div class="value">
                        <el-input v-model="addData.compnay" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="label">
                        案件类型:
                    </div>
                    <div class="value">
                        <el-input v-model="addData.CaseType" size="small" placeholder="请输入"></el-input>
                    </div>
                </div> -->
                <div class="item">
                    <div class="label">
                        省份:
                    </div>
                    <div class="value">
                        <el-tag
                            v-for="(tag,index) in addData.provinceList.province"
                            :key="tag"
                            closable
                            @close="handleCloseProvinceList(tag,index)"
                            >
                            {{tag}}
                        </el-tag>
                    </div>
                    <el-button type="primary" @click="isProvinceDialog=true" size="small" icon="el-icon-circle-plus">新增</el-button>
                </div>
                <el-switch
                    v-model="addData.provinceList.contain"
                    active-text="包含以上省份"
                    inactive-text="排除以上省份"
                    style="margin:15px">
                </el-switch>
                <div class="item">
                    <div class="label">
                        城市:
                    </div>
                    <div class="value">
                        <el-tag
                            v-for="(tag,index) in addData.cityHandlerList.city"
                            :key="tag"
                            closable
                            @close="handleCloseCityList(tag,index)"
                            >
                            {{tag}}
                        </el-tag>
                    </div>
                    <el-button type="primary" @click="isCityDialog=true" size="small" icon="el-icon-circle-plus">新增</el-button>
                </div>
                <el-switch
                    v-model="addData.cityHandlerList.contain"
                    active-text="包含以上城市"
                    inactive-text="排除以上城市"
                    style="margin:15px">
                </el-switch>
                <div class="item">
                    <div class="label">
                        人伤岗:
                    </div>
                    <div class="valuerow">
                        <el-input v-model="addData.userName" size="small" placeholder="请输入" disabled></el-input>
                        <el-button type="primary" @click="isUserListDialog = true" size="small">选 择</el-button>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="isAddDialog = false">取 消</el-button>
                    <el-button type="primary" @click="autoConfigureAdd">确 定</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isEditDialog" title="编辑" width="600px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        公司名称:
                    </div>
                    <div class="value">
                        <el-input v-model="addData.compnay" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="label">
                        案件类型:
                    </div>
                    <div class="value">
                        <el-input v-model="addData.CaseType" size="small" placeholder="请输入"></el-input>
                    </div>
                </div> -->
                <div class="item">
                    <div class="label">
                        省份:
                    </div>
                    <div class="value">
                        <el-tag
                            v-for="(tag,index) in addData.provinceList.province"
                            :key="tag"
                            closable
                            @close="handleCloseProvinceList(tag,index)"
                            >
                            {{tag}}
                        </el-tag>
                    </div>
                    <el-button type="primary" @click="isProvinceDialog=true" size="small" icon="el-icon-circle-plus">新增</el-button>
                </div>
                <el-switch
                    v-model="addData.provinceList.contain"
                    active-text="包含以上省份"
                    inactive-text="排除以上省份"
                    style="margin:15px">
                </el-switch>
                <div class="item">
                    <div class="label">
                        城市:
                    </div>
                    <div class="value">
                        <el-tag
                            v-for="(tag,index) in addData.cityHandlerList.city"
                            :key="tag"
                            closable
                            @close="handleCloseCityList(tag,index)"
                            >
                            {{tag}}
                        </el-tag>
                    </div>
                    <el-button type="primary" @click="isCityDialog=true" size="small" icon="el-icon-circle-plus">新增</el-button>
                </div>
                <el-switch
                    v-model="addData.cityHandlerList.contain"
                    active-text="包含以上城市"
                    inactive-text="排除以上城市"
                    style="margin:15px">
                </el-switch>
                <div class="item">
                    <div class="label">
                        人伤岗:
                    </div>
                    <div class="valuerow">
                        <el-input v-model="addData.userName" size="small" placeholder="请输入" disabled></el-input>
                        <el-button type="primary" @click="isUserListDialog = true" size="small">选 择</el-button>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="isEditDialog = false">取 消</el-button>
                    <el-button type="primary" @click="autoConfigureEdit">确 定</el-button>
                </div>
            </div>
        </el-dialog>
       

        <el-dialog :close-on-click-modal="false" :visible.sync="isProvinceDialog" title="新增省份" width="400px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        省份:
                    </div>
                    <div class="value">
                        <el-input v-model="provinceData" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="addProvince">确认新增</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="isCityDialog" title="新增城市" width="400px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        城市:
                    </div>
                    <div class="value">
                        <el-input v-model="cityData" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="addCity">确认新增</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isUserListDialog" title="人员列表" width="1200px">
            <div class="condition">
                <div class="item">
                    <div class="label">人员名称:</div>
                    <el-input v-model="conditionData.Name" size="small" placeholder="请输入"></el-input>
                </div>
                <div class="item">
                    <div class="label">账号:</div>
                    <el-input v-model="conditionData.Phone" size="small" placeholder="请输入"></el-input>
                </div>
                <div class="btns">
                    <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                    <el-button type="warning" size="small" @click="reset()">重置</el-button>
                </div>
            </div>
            <el-table
                :data="userList"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column
                type="selection"
                width="80"
                align="center"
                >
                </el-table-column>
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="name"
                label="用户名称"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="phone"
                label="账号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="roleNames"
                label="关联角色"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="enable"
                label="是否启用"
                align="center"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.enable">启用</span>
                    <span v-else>禁用</span>
                </template>
                </el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="100px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="affirmUser(scope.row)">确认</el-button>
                    <!-- <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteUser(scope.row)">删除</el-button> -->
                </template>
                </el-table-column>
                
            </el-table>
            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next, total"
                    :total="usertotalCount"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import api from '../../../api/main'
export default {
    name: 'person',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            title:'',
            isShow:false,
            isAddDialog:false,
            isEditDialog:false,
            isUpdateDialog:false,
            totalCount:0,
            conditionData:{
                Name:'',
                Phone:'',
                page:1,
                pageSize:10,
            },
            addData:{
                CaseType:0,
                provinceList:{
                    province:[],
                    contain: true
                },
                cityHandlerList:{
                    city:[],
                    contain: true
                },
            },
            editData:{
                CaseType:0,
                provinceList:{
                    province:[],
                    contain: true
                },
                cityHandlerList:{
                    city:[],
                    contain: true
                },
            },
            updateData:{},
            tableData:[],
            provinceData:'',
            cityData:'',

            isProvinceDialog:false,
            isCityDialog:false,
            userList:[],
            usertotalCount:0,
            isUserListDialog:false,
        }
    },
    created(){
        
    },
    mounted(){
        this.queryUsers();
        this.loadingData();
    },
    methods:{
    
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let res  = await api.autoConfigureQueryAll(this.conditionData);
            console.log(res);
            this.tableData = res.data.data;
            for(let i in this.tableData){
                console.log(this.tableData[i]);
                let province = this.tableData[i].provinceList.province;
                let city = this.tableData[i].cityHandlerList.city;


                this.tableData[i].provinceListStr='';
                this.tableData[i].cityListStr='';
                for(let index in province){
                    this.tableData[i].provinceListStr = this.tableData[i].provinceListStr+(this.tableData[i].provinceListStr?'、':'')+province[index];
                }

                for(let index in city){
                    this.tableData[i].cityListStr = this.tableData[i].cityListStr+(this.tableData[i].cityListStr?'、':'')+city[index];
                }

            }
        },
        selectData(){
            this.conditionData.page = 1;
            this.queryUsers();
        },
        reset(){
            this.conditionData = {
                Name:'',
                Phone:'',
                page:1,
                pageSize:10,
            },
            this.queryUsers();
        },
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.queryUsers();
        },
        showAddDialog(){
            this.addData={
                provinceList:{
                    province:[],
                    contain: true,

                },
                cityHandlerList:{
                    city:[],
                    contain: true,
                },
            };
            this.isAddDialog = true;
        },
       
        async autoConfigureAdd(){
            let res  = await api.autoConfigureAdd(this.addData);
            if(res.data.code == '200') {
                this.$message({
                    message: '添加成功',
                    type: 'success'
                });
                this.addData={
                    provinceList:{
                        province:[],
                        contain: true,

                    },
                    cityHandlerList:{
                        city:[],
                        contain: true,
                    },
                };
                this.loadingData();
                this.isAddDialog = false;
            }

        },
        async autoConfigureEdit(){
            let res  = await api.autoConfigureUpdate(this.addData);
            if(res.data.code == '200') {
                this.$message({
                    message: '添加成功',
                    type: 'success'
                });
                this.addData={
                    provinceList:{
                        province:[],
                    },
                    cityHandlerList:{
                        city:[],
                    },
                };
                this.loadingData();
                this.isEditDialog = false;
            }
        },
        async deleteAutoConfigureTip(row){
            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteAutoConfigure(row.id);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        async deleteAutoConfigure(id){
            let res  = await api.autoConfigureDelete(id);
            console.log(res);
            if(res.data.code == '200') {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.loadingData();
            }
        },
        
        isUpdateDialogShow(row){
            this.isEditDialog = true;
            this.addData = row;
        },
        async queryUsers(){
            let res = await api.QueryUsers(this.conditionData);
            this.userList = res.data.data.data;
            this.usertotalCount = res.data.data.totalCount;

            
        },
        affirmUser(row){
            console.log(row);
            this.addData.userId=row.id;
            this.addData.userName=row.name;
            this.isUserListDialog = false;
        },
        addProvince(){
            this.addData.provinceList.province.push(this.provinceData);
            this.isProvinceDialog = false;
            this.provinceData = '';
        },
        addCity(){
            this.addData.cityHandlerList.city.push(this.cityData);
            this.isCityDialog = false;
            this.cityData = '';
        },

      
        
        handleCloseProvinceList(tag,index) {
            this.addData.provinceList.province.splice(index, 1);
        },
        handleCloseCityList(tag,index) {
            this.addData.cityHandlerList.city.splice(index, 1);
        },
    }
    
}
</script>

<style lang="scss" scoped>
    /deep/.el-tag{
        margin: 5px 0;
        margin-right: 10px;
    }
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            .label{
                min-width: 110px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
    /deep/.el-input.is-disabled .el-input__inner{
        color: #606266;
    }
    .dialog{
        padding-top: 20px;
        height: 100%;
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                width:100px;
                margin-bottom: 5px;
            }
            .value{
                max-width:350px;
                margin-bottom: 5px;
                display: flex;
                flex-wrap: wrap;
            }
            .valuerow{
                max-width:350px;
                margin-bottom: 5px;
                display: flex;
            }
        }
        
        .dialog-footer{
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            justify-content: center;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
